import countries from "../helpers/avs-countries";

const CountryInput = (props) => {
  const {
    placeholder,
    ...selectProps
  } = props;

  return (
    <select {...selectProps}>
      <option value="">{placeholder || ""}</option>
      {countries.map(({ abbreviation, alpha_3_code, name }) => (
        <option
          key={alpha_3_code}
          value={abbreviation}
        >{name}</option>
      ))}
    </select>
  );
}

export default CountryInput;